import { useRef } from 'react';

const SWIPE_THRESHOLD = 50;

interface UseSwipeOptions {
    onSwipeLeft?: () => void;
    onSwipeRight?: () => void;
}

export function useSwipe({ onSwipeLeft, onSwipeRight }: UseSwipeOptions) {
    const touchStartX = useRef<number | null>(null);

    const onTouchStart = (e: React.TouchEvent | TouchEvent) => {
        if (e.touches.length === 0) return;
        touchStartX.current = e.touches[0].clientX;
    };

    const onTouchEnd = (e: React.TouchEvent | TouchEvent) => {
        if (touchStartX.current === null || e.changedTouches.length === 0)
            return;
        const deltaX = e.changedTouches[0].clientX - touchStartX.current;
        touchStartX.current = null;

        if (deltaX > SWIPE_THRESHOLD) {
            onSwipeRight?.();
        } else if (deltaX < -SWIPE_THRESHOLD) {
            onSwipeLeft?.();
        }
    };

    return { onTouchStart, onTouchEnd };
}
